import { motion } from "framer-motion";
import { Card } from "../../../components/ui/Card";

export function Integration() {
  return (
    <section className="relative py-32">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card variant="hover" className="p-12">
          <div className="text-center mb-12">
            <h2 className="aurora-gradient">Seamless Integrations</h2>
            <p className="text-white/70 text-lg mx-auto">
              Connect with your favorite tools and platforms
            </p>
          </div>
          <div className="flex justify-center gap-12 flex-wrap">
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center gap-3 px-6 py-3 rounded-xl bg-white/10 backdrop-blur-sm"
            >
              <img src="/logos/github.png" alt="GitHub" className="w-6 h-6" />
              <span className="font-medium">GitHub</span>
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center gap-3 px-6 py-3 rounded-xl bg-white/10 backdrop-blur-sm"
            >
              <img src="/logos/gitlab.webp" alt="GitLab" className="w-6 h-6" />
              <span className="font-medium">GitLab</span>
            </motion.div>
            <motion.div
              whileHover={{ scale: 1.05 }}
              className="flex items-center gap-3 px-6 py-3 rounded-xl bg-white/10 backdrop-blur-sm"
            >
              <img
                src="/logos/bitbucket.png"
                alt="Bitbucket"
                className="w-6 h-6"
              />
              <span className="font-medium">Bitbucket</span>
            </motion.div>
          </div>
        </Card>
      </div>
    </section>
  );
}
